import { useMutation, useQuery, useQueryClient } from 'react-query'
import toast from 'react-hot-toast'

import { format, parseISO } from 'date-fns'

import { useAuth } from '../contexts/AuthContext'
import { api } from '../utils/api'

const useSuperEnd = ({ id }) => {
  const queryClient = useQueryClient()
  const { checkAccessToken } = useAuth()

  const getSuperEndDraft = useQuery(
    ['getSuperEndDraft'],
    async () => {
      await checkAccessToken()
      const { data } = await api.get(`/superendpassdown/draft`)
      return data
    },
    {
      onError: (error) =>
        error?.response.data.errors.forEach((err) => {
          toast.error(err.msg)
        }),
    }
  )

  const patchSuperEndWetDraft = useMutation(
    async (values) => {
      if (values?.wetDate) {
        if (typeof values.wetDate == 'string') {
          values.wetDate = format(
            parseISO(values.wetDate),
            `yyyy-MM-dd'T'00:00:00.000-07:00`
          )
        } else {
          values.wetDate = format(
            values.wetDate,
            `yyyy-MM-dd'T'00:00:00.000-07:00`
          )
        }
      }

      const { data } = await api.patch(
        `/superendpassdown/draft/wet/${id}`,
        values
      )
      return data
    },
    {
      onMutate: async (data) => {
        await queryClient.cancelQueries(['getSuperEndDraft'])
        const previousValue = queryClient.getQueryData(['getSuperEndDraft'])
        return previousValue
      },

      onError: (error, variables, previousValue) => {
        queryClient.setQueryData(['getSuperEndDraft'], previousValue)
        error?.response.data.errors.forEach((err) => {
          toast.error(err.msg)
        })
        toast.error(
          'Because of the previous error data has been reverted to the last saved state, please try again'
        )
      },
      onSuccess: (data) => {
        toast.success(`Success: Super End Wet Passdown ${data._id} updated`)
      },
      onSettled: () => {
        queryClient.invalidateQueries(['getSuperEndDraft'])
      },
    }
  )

  const patchSuperEndDryDraft = useMutation(
    async (values) => {
      if (values?.dryDate) {
        if (typeof values.dryDate == 'string') {
          values.dryDate = format(
            parseISO(values.dryDate),
            `yyyy-MM-dd'T'00:00:00.000-07:00`
          )
        } else {
          values.dryDate = format(
            values.dryDate,
            `yyyy-MM-dd'T'00:00:00.000-07:00`
          )
        }
      }

      const { data } = await api.patch(
        `/superendpassdown/draft/dry/${id}`,
        values
      )
      return data
    },
    {
      onMutate: async (data) => {
        await queryClient.cancelQueries(['getSuperEndDraft'])
        const previousValue = queryClient.getQueryData(['getSuperEndDraft'])
        return previousValue
      },

      onError: (error, variables, previousValue) => {
        queryClient.setQueryData(['getSuperEndDraft'], previousValue)
        error?.response.data.errors.forEach((err) => {
          toast.error(err.msg)
        })
        toast.error(
          'Because of the previous error data has been reverted to the last saved state, please try again'
        )
      },
      onSuccess: (data) => {
        toast.success(`Success: Super End Dry Passdown ${data._id} updated`)
      },
      onSettled: () => {
        queryClient.invalidateQueries(['getSuperEndDraft'])
      },
    }
  )

  const postSuperEndEmailDraft = useMutation(
    async () => {
      const { data } = await api.post(`/superendpassdown/draft/email`)
      return data
    },
    {
      onMutate: async (data) => {
        await queryClient.cancelQueries(['getSuperEndDraft'])
        const previousValue = queryClient.getQueryData(['getSuperEndDraft'])
        return previousValue
      },
      onError: (error, variables, previousValue) => {
        queryClient.setQueryData(['getSuperEndDraft'], previousValue)
        error?.response.data.errors.forEach((err) => {
          toast.error(err.msg)
        })
      },
      onSuccess: () => {
        toast.success(`Success: Supervisor End Shift Passdown Email sent`)
      },
      onSettled: () => {
        queryClient.invalidateQueries(['getSuperEndDraft'])
      },
    }
  )

  return {
    getSuperEndDraft,
    patchSuperEndWetDraft,
    patchSuperEndDryDraft,
    postSuperEndEmailDraft,
  }
}

export default useSuperEnd
